import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deletePriceAdjustment = (
    token: string,
    backend: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}price_lists/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deletePriceAdjustment;
